<template>
  <section class="resume-section" id="interests">
    <div class="resume-section-content">
      <h2 class="mb-5">Interests</h2>
      <div
        class="resume-item d-flex flex-column flex-md-row justify-content-between mb-5"
        v-if="interests.isLoading"
      >
        <ListLoader />
      </div>

      <div
        class="resume-item d-flex flex-column flex-md-row justify-content-between mb-5"
        v-for="interest in interests"
        :key="interest.id"
      >
        <div class="resume-content">
          <h3>{{ interest.name }}</h3>
          <p>
            {{ interest.description }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { ListLoader } from "vue-content-loader";

export default {
  components: { ListLoader },
  computed: mapGetters(["interests"]),
  methods: mapActions(["fetchInterests"]),
  created() {
    this.fetchInterests();
  },
};
</script>
